import { UNIFIED_DATA_TYPES } from '../constants/dataTypes';
// @ts-expect-error Untyped import
import { load } from '../dataTypeDefinitions';
export const isBreakdownDimensionSupportedForDataType = async dataType => {
  var _await$dataTypeDefini, _dataTypeDefinitionMo;
  if (!UNIFIED_DATA_TYPES.includes(dataType)) {
    return false;
  }
  const dataTypeDefinitionModule = await load(dataType);

  // note: check is not guaranteed to work as all modules have slight variance
  return !!((_await$dataTypeDefini = await (dataTypeDefinitionModule === null || dataTypeDefinitionModule === void 0 || (_dataTypeDefinitionMo = dataTypeDefinitionModule.getUnifiedSpecForConfig) === null || _dataTypeDefinitionMo === void 0 ? void 0 : _dataTypeDefinitionMo.call(dataTypeDefinitionModule))) !== null && _await$dataTypeDefini !== void 0 && (_await$dataTypeDefini = _await$dataTypeDefini.url) !== null && _await$dataTypeDefini !== void 0 && _await$dataTypeDefini.includes('activities/v2/reports'));
};

/**
 * Gets the metadata defined on the unified spec for the given data type
 * @param dataType The data type to get metadata for
 * @returns An object containing the metadata, or null if the data type is not supported
 */
export const getMetadata = async dataType => {
  var _await$dataTypeDefini2, _await$dataTypeDefini3, _dataTypeDefinitionMo2;
  if (!UNIFIED_DATA_TYPES.includes(dataType)) {
    return null;
  }
  const dataTypeDefinitionModule = await load(dataType);
  return (_await$dataTypeDefini2 = (_await$dataTypeDefini3 = await (dataTypeDefinitionModule === null || dataTypeDefinitionModule === void 0 || (_dataTypeDefinitionMo2 = dataTypeDefinitionModule.getUnifiedSpecForConfig) === null || _dataTypeDefinitionMo2 === void 0 ? void 0 : _dataTypeDefinitionMo2.call(dataTypeDefinitionModule))) === null || _await$dataTypeDefini3 === void 0 ? void 0 : _await$dataTypeDefini3.metadata) !== null && _await$dataTypeDefini2 !== void 0 ? _await$dataTypeDefini2 : null;
};